import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private http = inject(HttpClient);

  // TODO
  getSalesTaxPaidByYear(year: number): Observable<any> {
    return this.http.get<any>(`/reports/finances/paidSalesTax/${year}`);
  }

  exportSalesTaxPaidByYear(year: number): void {
    const url = new URL(
      `/api/reports/finances/paidSalesTax/${year}/export`,
      environment.apiUrl
    );
    window.open(url.toString());
  }
}
